import React from 'react';
import { Link } from "gatsby";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

library.add(fab)

const className = {
    container: "container",
    navTop: 'nav-top nav-top--top'
}

export default function HeaderTop() {
  return (
    <div className={className.navTop}>
      <div className={className.container}>
        <div className="d-flex justify-content-between">
        <ul className="social-menu">
          <li className="social-menu__list">
            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" className="social-menu__link">
              <FontAwesomeIcon icon={['fab', 'facebook-f']} className="social-menu__icon" />
            </a>  
          </li>
          <li className="social-menu__list">
            <a href="http://bit.ly/gardenTeam" target="_blank" rel="noopener noreferrer" className="social-menu__link">
              <FontAwesomeIcon icon={['fab', 'whatsapp']} className="social-menu__icon" />
            </a>  
          </li>
          <li className="social-menu__list">
            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="social-menu__link">
              <FontAwesomeIcon icon={['fab', 'instagram']} className="social-menu__icon" />
            </a>  
          </li>
        </ul>

        <ul className="nav-menu">
          <li className="nav-menu__list">
            <a href="tel:+91-980175567" className="nav-menu__link">
              <FontAwesomeIcon icon={faPhone} style={ { transform: "scaleX(-1)" } }/>
              <span className="phone-text">+91-9980175567</span>
            </a>
          </li>
          <li className="nav-menu__list">
            <Link to="/" className="nav-menu__link">
              bangalore
            </Link>
          </li>
          <li className="nav-menu__list">
            <Link to="/" className="nav-menu__link">
              how it works
            </Link>
          </li>
          <li className="nav-menu__list">
            <Link to="/" className="nav-menu__link">
              magazine 
            </Link>
          </li>
          <li className="nav-menu__list">
            <Link to="/" className="nav-menu__link">
              projects 
            </Link>
          </li>
          {/* <li className="nav-menu__list">
            <a href="#" className="nav-menu__link">
              <FontAwesomeIcon icon={faShoppingCart} /> 
            </a>
          </li> */}
        </ul>
        </div>
       
      </div>
      
    </div>
  )
}
